<script>
import VueSelect from 'vue-select';

export default {
    components: {
        VueSelect
    },

    props: {
        disabled: {
            type: Boolean,
            required: true
        },
        competencies: {
            type: Array,
            required: true
        },
        type: {
            type: String, // knowledge, skill, attribute, etc.
            required: true
        },
        title: {
            type: String,
            required: true
        },
        selectedPreferredIds: {
            type: Array,
            required: true
        },
        selectedEssentialIds: {
            type: Array,
            required: true
        }
    },

    computed: {
        availableEssentialComps() {
            return this.competencies.filter(comp => !this.preferredCompetencyIds.includes(comp.id))
        },
        availablePreferredComps() {
            return this.competencies.filter(comp => !this.essentialCompetencyIds.includes(comp.id))
        }
    },

    data() {
        return {
            essentialCompetencyIds: this.selectedEssentialIds,
            preferredCompetencyIds: this.selectedPreferredIds,
        }
    },
}
</script>

<template>
    <div class="grid-x grid-padding-x mb-2">
        <div class="cell medium-6 large-5">
            <label v-if="title === 'Attribute'">Competencies Essential</label>
            <label v-else>{{ title }} Essential</label>
            <vue-select
                class="personspec-dropdown"
                :disabled="disabled"
                label="title"
                :reduce="competency => competency.id"
                :options="availableEssentialComps"
                v-model="essentialCompetencyIds"
                :multiple="true"
            />

            <template v-if="essentialCompetencyIds.length > 0">
                <template v-for="(id, index) in essentialCompetencyIds">
                    <input :name="`essential_${type}_competencies[${index}][id]`" :value="id" type="hidden" />
                    <input :name="`essential_${type}_competencies[${index}][_joinData][competency]`" :value="type" type="hidden" />
                    <input :name="`essential_${type}_competencies[${index}][_joinData][is_essential]`" :value="1" type="hidden" />
                </template>
            </template>
            <input v-else :name="`essential_${type}_competencies`" value="" type="hidden" />
        </div>

        <div class="cell medium-6 large-5">
            <label v-if="title === 'Attribute'">Competencies Preferential</label>
            <label v-else>{{ title }} Preferential</label>
            <vue-select
                class="personspec-dropdown"
                :disabled="disabled"
                label="title"
                :reduce="competency => competency.id"
                :options="availablePreferredComps"
                v-model="preferredCompetencyIds"
                :multiple="true"
            />

            <template v-if="preferredCompetencyIds.length > 0">
                <template v-for="(id, index) in preferredCompetencyIds">
                    <input :name="`preferred_${type}_competencies[${index}][id]`" :value="id" type="hidden" />
                    <input :name="`preferred_${type}_competencies[${index}][_joinData][competency]`" :value="type" type="hidden" />
                    <input :name="`preferred_${type}_competencies[${index}][_joinData][is_essential]`" :value="0" type="hidden" />
                </template>
            </template>
            <input v-else :name="`preferred_${type}_competencies`" value="" type="hidden" />
        </div>
    </div>
</template>